import { render } from "./AddressesList.vue?vue&type=template&id=04b21667"
import script from "./AddressesList.vue?vue&type=script&lang=js"
export * from "./AddressesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front-twint-ux/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__